export const kAppConfig = {
    backendPostRequestChunkSize: 25,
    initialProspectQueryFromDay: -7,
    mecoInboxDomain: process.env.REACT_APP_STAGE === 'production' ? "@mecoinbox.com" : "@stage.mecoinbox.com",
    aiAudioDefaultGroupName: "Daily Brief 🎧"
}